import api from '@/utils/api';

/**
 * Logout user
 * @returns {Promise}
 */
const LogoutApi = () => api.post('auth/logout');
export default LogoutApi;
